import React,{ useEffect, useState } from 'react';
import { history, useLocation } from 'umi';
import {Page,InfiniteLoader } from 'react-weui';
import { Toast,Tabs } from 'antd-mobile';
import styles from './styles.scss';
import Empty from '@/components/empty';

import { likeMeLog } from '@/services/myself';
import { programCommentLikeLog } from '@/services/program';


export default () => {
  const [page, setPage] = useState(0);
  const tabs = [
    { title: '课程' },
    { title: '栏目' },
  ];


  return (
    <div>

      <Tabs
        tabs={tabs}
        page={page}
        tabBarActiveTextColor={'#333333'}
        tabBarInactiveTextColor={'#888888'}
        tabBarUnderlineStyle={{ backgroundColor: 'transparent', height: '2' }}
        onChange={(tab, index) => {
          setPage(index)
        }}
        onTabClick={(tab, index) => {
          setPage(index)
        }}
      >
        <CourseList/>
        <ProgramList/>
      </Tabs>
    </div>
  )

}

const CourseList = (props) => {

  const [dataList,setDataList] = useState([]);
  const [pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  useEffect(()=>{
    getList(pageNo);
  },[]);

  function getList(page,resolve,finish) {

    likeMeLog({pageNo:page,pageSize:20}).then(res =>{

      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return(
    <InfiniteLoader
          onLoadMore={(resolve,finish) =>{
            if (dataList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            getList(pageNo+1,resolve,finish);
          }}
    >

      {dataList.length ? dataList.map(item =>(
        <div className={styles.itemBox} key={item.id} onClick={()=>{
          history.push('/home/courseDetail?courseId=' + item.courseId + '&title=' + item.course.name);
        }}>

          <div className={styles.likeMember}>
            <img src={item.member.avatarurl}/>
            <div style={{display:'flex',flexDirection:'column',marginLeft:'10px'}}>
              <label className={styles.likeMemberName}>{item.member.nickname}</label>
              <label className={styles.likeTime}>{item.createDate}</label>
            </div>
          </div>

          <div className={styles.likeComment}>{'赞了你的评论：' + item.memberCourseComment.content}</div>

          <div className={styles.courseBox}>
            <img src={item.course.image}/>
            <label>{item.course.name}</label>
          </div>

        </div>
      )) : <Empty text={'暂无消息'}/>}
      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}




    </InfiniteLoader>
  )
}




const ProgramList = (props) => {

  const [dataList,setDataList] = useState([]);
  const [pageNo,setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0); // 新增总条数


  useEffect(()=>{
    getList(pageNo);
  },[]);

  function getList(page,resolve,finish) {

    programCommentLikeLog({pageNo:page,pageSize:20}).then(res =>{

      if (res.code == 200) {
        setTotalCount(res.data.count || 0); // 更新总条数
        if (page == 1) {
          setDataList(res.data.list);
        } else {
          setDataList(prev => prev.concat(res.data.list));
        }
        setPageNo(page);
        resolve && resolve();
        // 不再用list.length判断finish，由onLoadMore统一判断

      } else {
        Toast.fail(res.message,1);
        resolve && resolve();
      }

    }).catch(e =>{
      Toast.fail('请求失败，请重试',1);
      resolve && resolve();
    });
  }


  return(
    <InfiniteLoader
          onLoadMore={(resolve,finish) =>{
            if (dataList.length >= totalCount && totalCount !== 0) {
              finish();
              return;
            }
            getList(pageNo+1,resolve,finish);
          }}
    >

      {dataList.length ? dataList.map(item =>(
        <div className={styles.itemBox} key={item.id} onClick={()=>{
          history.push('/program/programDetail?programId=' + item.columnId + '&title=' + item.column.name);
        }}>

          <div className={styles.likeMember}>
            <img src={item.member.avatarurl}/>
            <div style={{display:'flex',flexDirection:'column',marginLeft:'10px'}}>
              <label className={styles.likeMemberName}>{item.member.nickname}</label>
              <label className={styles.likeTime}>{item.createDate}</label>
            </div>
          </div>

          <div className={styles.likeComment}>{'赞了你的评论：' + item.columnComment.content}</div>

          <div className={styles.courseBox}>
            <img src={item.column.image}/>
            <label>{item.column.name}</label>
          </div>

        </div>
      )) : <Empty text={'暂无消息'}/>}
      {dataList.length >= totalCount && totalCount !== 0 && (
        <div style={{ textAlign: 'center', color: '#888', padding: '12px 0' }}>
          没有更多数据了
        </div>
      )}




    </InfiniteLoader>
  )
}

